var resourcePaths;
if ('test' !== process.env.NODE_ENV) {
  resourcePaths = {
    // cdn resources with fallbacks
    bugsnag: ['//d2wy8f7a9ursnm.cloudfront.net/bugsnag-2.min.js?', 'bugsnag'],
    bugsnagTracking: 'bugsnagTracking',
    'react-dom': ['//unpkg.com/react-dom@17.0.2/umd/react-dom.production.min.js?', 'react-dom'],
    react: ['//unpkg.com/react@17.0.2/umd/react.production.min.js?', 'react'],
    'prop-types': ['//cdnjs.cloudflare.com/ajax/libs/prop-types/15.7.2/prop-types.min.js?', 'prop-types'],
    jquery: ['//code.jquery.com/jquery-3.3.1.min.js?', 'jquery'],
    jqueryMigrate: ['//code.jquery.com/jquery-migrate-3.0.0.min.js?', 'jqueryMigrate'],
    bootstrap: ['//maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js?', 'boostrap'],
    cloudinaryWidget: ['//widget.cloudinary.com/v2.0/global/all.js', 'cloudinaryWidget'],
    googleMaps: ['//maps.googleapis.com/maps/api/js?key=' + window.googleAPIKey + '&libraries=places&language=' + window.googleLang, 'googleMaps'],
    lodash: ['//cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.15/lodash.min.js?', 'lodash.min'],
    stripe: ['https://js.stripe.com/v2/stripe'],
    // still local
    cloudinary: 'jquery.cloudinary.js?v=1750979650',
    lazysizes: 'lazysizes',
    moment: 'moment.min',
    momentTz: 'moment-timezone-with-data-2010-2020.min',
    sifter: 'sifter',
    // these are ours
    analyticsIntegrations: 'analytics-integrations.js?v=1750979650',
    attr: 'attr-cookie.js?v=1750979650',
    sessions: 'sessions.js?v=1750979650',
    nav: '../build/nav.bundle.js?v=1750979650',
    activities: '../build/activity.bundle.js?v=1750979650',
    bookingsRequest: '../build/bookings-request-app.bundle.js?v=1750979650',
    attendeePage: '../build/attendee-page.bundle.js?v=1750979650',
    signinpage: '../build/full-page-login.bundle.js?v=1750979650',
    listing: 'listing-template.js?v=1750979650',
    reactCollection: '../build/collection.bundle.js?v=1750979650',
    reactSearch: '../build/search.bundle.js?v=1750979650',
    listingSocial: 'listing-social.js?v=1750979650',
    collectionsSocial: 'collections-social.js?v=1750979650',
    profilesSocial: 'profile-social.js?v=1750979650',
    heroSearch: '_hero-dropdown.js?v=1750979650',
    main: '../build/main.bundle.js?v=1750979650',
    spaceWidget: '../build/host.bundle.js?v=1750979650',
    facebook: '//connect.facebook.net/en_US/sdk',
    spaceType: '../build/space-type.bundle.js?v=1750979650',
    termsUpdate: '../build/terms-update.bundle.js?v=1750979650',
    optimizeLoad: 'optimize_loaded.js?v=1750979650',
    hero: '../build/hero.bundle.js?v=1750979650',
    homepage: '../build/homepage.bundle.js?v=1750979650',
    profileSharing: '../build/profileSharing.bundle.js?v=1750979650',
    footer: '../build/footer.bundle.js?v=1750979650'
  };
} else {
  resourcePaths = {
    // cdn resources with fallbacks
    bugsnag: ['//d2wy8f7a9ursnm.cloudfront.net/bugsnag-2.min.js?', 'bugsnag'],
    bugsnagTracking: 'bugsnagTracking',
    'react-dom': ['//unpkg.com/react-dom@17.0.2/umd/react-dom.development.js?', 'react-dom'],
    react: ['//unpkg.com/react@17.0.2/umd/react.development.js?', 'react'],
    'prop-types': ['//cdnjs.cloudflare.com/ajax/libs/prop-types/15.7.2/prop-types.js?', 'prop-types'],
    jquery: ['https://code.jquery.com/jquery-3.3.1.js?', 'jquery'],
    jqueryMigrate: ['//code.jquery.com/jquery-migrate-3.0.0.js?', 'jqueryMigrate'],
    bootstrap: ['//maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.js?', 'boostrap'],
    cloudinaryWidget: ['//widget.cloudinary.com/v2.0/global/all.js', 'cloudinaryWidget'],
    googleMaps: ['//maps.googleapis.com/maps/api/js?key=' + window.googleAPIKey + '&libraries=places&language=' + window.googleLang, 'googleMaps'],
    lodash: ['//cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.15/lodash.min.js?', 'lodash.min'],
    stripe: ['https://js.stripe.com/v2/stripe'],
    // still local
    cloudinary: 'jquery.cloudinary.js?v=1750979650',
    lazysizes: 'lazysizes',
    moment: 'moment.min',
    momentTz: 'moment-timezone-with-data-2010-2020.min',
    sifter: 'sifter',
    // these are ours
    analyticsIntegrations: 'analytics-integrations.js?v=1750979650',
    attr: 'attr-cookie.js?v=1750979650',
    sessions: 'sessions.js?v=1750979650',
    nav: '../build/nav.bundle.js?v=1750979650',
    activities: '../build/activity.bundle.js?v=1750979650',
    bookingsRequest: '../build/bookings-request-app.bundle.js?v=1750979650',
    attendeePage: '../build/attendee-page.bundle.js?v=1750979650',
    signinpage: '../build/full-page-login.bundle.js?v=1750979650',
    listing: 'listing-template.js?v=1750979650',
    reactCollection: '../build/collection.bundle.js?v=1750979650',
    reactSearch: '../build/search.bundle.js?v=1750979650',
    listingSocial: 'listing-social.js?v=1750979650',
    collectionsSocial: 'collections-social.js?v=1750979650',
    profilesSocial: 'profile-social.js?v=1750979650',
    heroSearch: '_hero-dropdown.js?v=1750979650',
    main: '../build/main.bundle.js?v=1750979650',
    spaceWidget: '../build/host.bundle.js?v=1750979650',
    facebook: '//connect.facebook.net/en_US/sdk',
    spaceType: '../build/space-type.bundle.js?v=1750979650',
    termsUpdate: '../build/terms-update.bundle.js?v=1750979650',
    optimizeLoad: 'optimize_loaded.js?v=1750979650',
    hero: '../build/hero.bundle.js?v=1750979650',
    profileSharing: '../build/profileSharing.bundle.js?v=1750979650',
    homepage: '../build/homepage.bundle.js?v=1750979650',
    footer: '../build/footer.bundle.js?v=1750979650'
  };
}

requirejs.config({
  baseUrl: '/web-templates/assets/public/js/dist',
  shim: {
    sessions: {
      exports: 'Cookies'
    },
    googleMaps: {
      exports: 'google'
    },
    lodash: {
      exports: '_'
    },
    react: {
      exports: 'React'
    },
    'react-dom': {
      exports: 'ReactDOM'
    },
    'prop-types': {
      exports: 'PropTypes'
    },
    analyticsIntegrations: {
      exports: 'analyticsIntegrations'
    },
    bugsnag: {
      exports: 'Bugsnag'
    },
    moment: {
      exports: 'moment'
    },
    stripe: {
      exports: 'Stripe'
    },
    facebook: {
      exports: 'FB'
    }
  },
  waitSeconds: 0,
  paths: resourcePaths
});
